// Module
var code = `<ppm-pdf-page-print ng-repeat="page in \$ctrl.pages track by \$index" document="\$ctrl.document" patient="\$ctrl.patient" page="page.page" annotations="page.annotations" on-render="\$ctrl.handlePageRender()"></ppm-pdf-page-print>`;
// Exports
export default code;